import React from "react";
import { Instagram, Mail, Phone } from "lucide-react";
import { LOGO } from "@/assets/images";

export default function Footer({ t }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#1A1A1A] py-14 text-[#EAE4D9]/80"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <span className="inline-flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-[#F5F2EB]">
                <img
                  src={LOGO}
                  alt="Telleixako Benta"
                  className="h-full w-full object-cover"
                />
              </span>
              <div>
                <p className="font-serif-display text-2xl italic text-[#F5F2EB]">
                  Telleixako Benta
                </p>
                <p className="mt-1 font-body text-xs uppercase tracking-[0.3em] text-[#EAE4D9]/60">
                  {t.footer.tagline}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="mb-4 font-body text-xs uppercase tracking-[0.35em] text-[#A63D2F]">
              — {t.footer.contactTitle}
            </p>
            <ul className="space-y-3 font-body text-sm text-[#EAE4D9]/90">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#EAE4D9]/60" strokeWidth={1.5} />
                <a
                  href="tel:+34943291730"
                  data-testid="footer-phone"
                  className="link-underline hover:text-white"
                >
                  +34 943 29 17 30
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#EAE4D9]/60" strokeWidth={1.5} />
                <a
                  href="mailto:teleixakobenta@gmail.com"
                  data-testid="footer-mail"
                  className="link-underline hover:text-white"
                >
                  teleixakobenta@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram
                  className="h-4 w-4 text-[#EAE4D9]/60"
                  strokeWidth={1.5}
                />
                <a
                  href="https://instagram.com/telleixako_benta"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="link-underline hover:text-white"
                >
                  @telleixako_benta
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-[#F5F2EB]/15 pt-6 sm:flex-row sm:items-center">
          <p className="font-body text-xs uppercase tracking-[0.25em] text-[#EAE4D9]/55">
            © {year} Telleixako Benta · {t.footer.rights}
          </p>
          <p className="font-body text-xs uppercase tracking-[0.25em] text-[#EAE4D9]/55">
            Calle Telleria 16 · 20570 Bergara
          </p>
        </div>
      </div>
    </footer>
  );
}
